export default __webpack_public_path__ + "static/media/hospitality.36a755e0.jpg";